import React, { useState } from 'react';
import { Flex, Text, Button, Alert, } from '@smarterservices/smarter-ui';
import DualPane from '../../DualPane';
import StepInstructions from '../../Common/StepInstructions';
import { usePaneViewer } from '../../PaneViewer';
import SecondCameraVideo from '../Connection/SecondCameraVideo';
import InformationalVideo from '../../Common/InformationalVideo';
const SecondCameraPlacement = ({ stepData }) => {
  // Hook for navigation between panes
    const { onNext, setIsTaskComplete } = usePaneViewer();
    const [videoAcknowledged, setVideoAcknowledged] = useState(false);
    const [remoteVideoStatus, setRemoteVideoStatus] = useState('');

    const handleNext = () => {
      onNext(); 
      setIsTaskComplete(true);
    };

  return (
    <DualPane
      leftPane={
        <StepInstructions instructions={stepData?.body} />
      }
      rightPane={
        <Flex direction="column" padding="medium" alignItems="center">
          {!videoAcknowledged && <InformationalVideo
                                    sourceUrl={stepData?.informationalVideo?.url}
                                    isMandatory={stepData?.informationalVideo?.mandatory}
                                    acknowledgementText={stepData?.informationalVideo?.acknowledgement}
                                    onAcknowledgmentChange={(acknowledged) => setVideoAcknowledged(acknowledged)}
                                  />}
          {videoAcknowledged && (
            <>  
            {remoteVideoStatus !== 'timeout' && (
              <SecondCameraVideo
                onVideoLoaded={() => setRemoteVideoStatus('loaded')}
                onVideoTimeout={() => setRemoteVideoStatus('timeout')}
                loadTimeout={20} />
            )}
            {remoteVideoStatus === 'loaded' && (
              <Button
                color="primary"
                size="medium"
                onClick={handleNext}
                margin="medium 0 0 0"
                >
                {stepData?.buttonText || 'Continue'}
                </Button>
            )}
            {remoteVideoStatus === 'timeout' && (
              <>
                <Alert
                  variant="error"
                  size="medium"
                  margin="medium 0 0 0"
                  >
                    There was an issue obtaining the second camera video. 
                </Alert>
                <Button
                  color="primary"
                  size="medium"
                  onClick={() => setRemoteVideoStatus('')}
                  margin="medium 0 0 0"
                  >
                  {stepData?.buttonText || 'Try Again'}
                  </Button>
              </>
            )}
            </> 
          )}
        </Flex>
      }
    />
  );
};

export default SecondCameraPlacement;
